import React, { useCallback, useEffect, useState } from 'react';
import { Spinner } from 'reactstrap';
import TableDeliveryButton from '~/components/Operation/TablesOperation/TableDeliveryButton';
import { useAuth } from '~/context/AuthContext';
import { AutoSizer, List } from 'react-virtualized';
import { Content, ItemsCount, LoadingDiv } from '../styles';
import { Header, Bloco, StyleKanbanWarning, ContainerDelivery } from './styles';
import OrderAndamentoDelivery from '../../Items/OrderAndamentoDelivery';
import { EveryOrdersDelivery } from 'components/EveryOrdersDelivery';

export default function ({
  baskets,
  handleItemFinished,
  handleCancelItem,
  loading,
  handleItemReady,
  handleUpdate,
  hasOrderActive,
  countOrders,
  showNewOrderButton,
}) {
  const { user } = useAuth();
  const basketsFiltered = baskets?.filter(
    (order) => order.table.table_type === 'delivery' && !order.scheduled_to
  );

  const basketId = basketsFiltered
    .flatMap((bskt) => bskt)
    .map((baskets) => {
      return baskets.basket.id;
    });

  const basketIfood = basketsFiltered
    .flatMap((bskt) => bskt)
    .map((baskets) => {
      return baskets.basket.ifood_id;
    });

  const basketWithdrawal = basketsFiltered
    .flatMap((bskt) => bskt)
    .map((baskets) => {
      return baskets.with_withdrawal;
    });

  return (
    <Bloco>
      <Header>
        <div>{user.use_foody_delivery ? 'COZINHA' : 'EM ANDAMENTO'}</div>
        <ItemsCount style={{ color: '#ffa814' }}>{countOrders}</ItemsCount>
      </Header>

      <Content>
        {showNewOrderButton && (
          <TableDeliveryButton isScheduling={false} buttonColor="#ffa814" />
        )}
        {loading ? (
          <LoadingDiv>
            <Spinner color="warning" />
          </LoadingDiv>
        ) : (
          <AutoSizer>
            {({ width, height }) => (
              <List
                width={width}
                height={height - (showNewOrderButton ? 30 : 0)}
                rowCount={basketsFiltered.length}
                rowHeight={({ index }) => {
                  const item = basketsFiltered[index];
                  if (item.ifood_delivery_time) {
                    return 260;
                  }
                  return 222;
                }}
                rowRenderer={({ index, key, style }) => {
                  const item = basketsFiltered[index];
                  return (
                    <OrderAndamentoDelivery
                      key={item.session_id}
                      style={style}
                      handleCancelItem={handleCancelItem}
                      handleItemFinished={handleItemFinished}
                      item={item}
                      handleItemReady={handleItemReady}
                      handleUpdate={handleUpdate}
                    />
                  );
                }}
              />
            )}
          </AutoSizer>
        )}
        {!hasOrderActive && (
          <StyleKanbanWarning>
            <p style={{ color: '#666666' }}>Não há pedido</p>
            <p style={{ color: '#666666' }}>no momento</p>
          </StyleKanbanWarning>
        )}
      </Content>
      <EveryOrdersDelivery
        baskets={basketsFiltered}
        basketId={basketId}
        basketStatus={['accepted']}
        basketIfood={basketIfood}
        basketWithdrawal={basketWithdrawal}
      />
    </Bloco>
  );
}
